{
  "title": "Raulothim's Psychic Lance (UA)",
  "source": "Unearthed Arcana 78 - Draconic Options",
  "levelAndSchool": "4th-level enchantment",
  "level": 4,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You unleash a shimmering lance of psychic power from your forehead at a creature that you can see within range. Alternatively, you can utter the creature’s name. If the named target is within range, it gains no benefit from cover or invisibility as the lance homes in on it. If the named target isn’t within range, the lance dissipates, and the spell slot is not expended.",
    "The target must succeed on an Intelligence saving throw or take 10d6 psychic damage and be incapacitated until the start of your next turn.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, the damage increases by 1d6 for each slot level above 4th."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
